import React from "react";
import Modal from 'react-responsive-modal';
import { Link, Switch, Route } from 'react-router-dom'
// Dialog
import $ from 'jquery';

import Auto1 from './../docs/Auto-1.js'
import Auto2 from './../docs/Auto-2.js';
import Auto3 from './../docs/Auto-3.js';

// DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD

import autoImage from '../../imgs/tesla.png';
import wheel from '../../icons/wheel.svg';
import car from '../../icons/car.svg'
import speed from '../../icons/races.svg';



export default class Auto extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          open : false,
      }
  }


      onOpenModal = () => {
        this.setState({ open: true });
        $.fn.fullpage.setMouseWheelScrolling(false);
        $.fn.fullpage.setAllowScrolling(false);
      };

      onCloseModal = () => {
        this.setState({ open: false });
        $.fn.fullpage.setMouseWheelScrolling(true);
        $.fn.fullpage.setAllowScrolling(true);
      };

      onOpenContentModal = () => {
        this.setState({modalContentOpen: true})
      }

      onCloseContentModal = () => {
        this.setState({modalContentOpen: false})
      }

  render() {
    return (
      <section className="auto section">
      <div className="container">
        <div className="row center-xs start-md start-lg center-sm flex-center">
          <div className="col-xs-12 col-lg-6 col-md-6 col-sm-12">
            <h1 className="heading teslaHeading">Автомобиль</h1>
            <h2 className="subheading">Механическое транспортное средство, используемое обычно для перевозки по дорогам людей или грузов или для буксировки по дорогам транспортных средств, используемых для перевозки людей или грузов.</h2>
              <Link to=''>
                <div onClick={this.onOpenModal} className="button">
                  <span className="button__mask"/>
                  <span className="button__text">Открыть</span>
                  <span className="button__text button__text--bis">Открыть</span>
                </div>
              </Link>
            <Modal open={this.state.open} onClose={this.onCloseModal} little styles={
              {
                modal: {
                  padding: '2em',
                }
              }
            }>
            <div className='row center-xs modal'>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Auto-1'>
                  <img alt='' className='responsive-icon' src={speed} />
                  <p className='icon-heading'>История создания</p>
                </Link>
              </div>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Auto-2'>
                  <img alt='' className='responsive-icon' src={wheel} />
                  <p className='icon-heading'>Физические явления</p>
                </Link>
              </div>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Auto-3'>
                  <img alt='' className='responsive-icon' src={car} />
                  <p className='icon-heading'>Современный автомобиль</p>
                </Link>
              </div>
            </div>
            </Modal>
              <Modal open={this.state.modalContentOpen} onClose={this.onCloseContentModal}>
                <Switch>
                <Route exact path='/Auto-1' component={Auto1}/>
                <Route exact path='/Auto-2' component={Auto2}/>
                <Route exact path='/Auto-3' component={Auto3}/>
              </Switch>
              </Modal>
          </div>
          <div className="col-xs-12 col-md-6">
            <img className="tesla animate" src={autoImage} alt="alt"/>
          </div>
        </div>
      </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Auto.js